import { DetailCardLoader } from "../Parse1120Loader";

const DftSidebarLoaderItem = () => (
  <div className="t-flex t-gap-2 t-items-center t-justify-between t-py-2 t-pl-8 t-pr-8">
    <div className="t-space-y-1.5 t-w-full">
      <div className="t-bg-neutral-55 t-w-1/3 t-h-4 t-animate-pulse t-rounded"></div>
      <div className="t-bg-neutral-55 t-w-full t-h-9 t-animate-pulse t-rounded"></div>
    </div>
  </div>
);

export const ParseDftLoader = () => {
  return (
    <div className="t-flex t-gap-1">
      <div className="t-flex-1 t-bg-white t-overflow-hidden t-flex">
        <div className="t-w-32 t-bg-text-black" />
        <div className="t-space-y-2 t-flex-1 t-px-10 t-py-12">
          <div className="t-bg-neutral-55 t-h-5 t-w-32 t-rounded t-animate-pulse"></div>
          <div className="t-bg-neutral-55 t-h-4 t-w-2/3 t-rounded t-animate-pulse"></div>
          <DetailCardLoader />
          <DetailCardLoader />
          <DetailCardLoader />
        </div>
        <div className="t-w-32 t-bg-text-black" />
      </div>
      <div className="t-w-2/5 t-border t-border-solid t-border-l-0 t-border-t-0 t-border-b-0 t-border-neutral-10 t-bg-white t-overflow-y-auto">
        <div>
          <div className="t-space-y-2 t-pr-8  py-3 t-pl-8">
            <div className="t-bg-neutral-55 t-h-9 t-w-full t-animate-pulse t-rounded"></div>
          </div>
          <DftSidebarLoaderItem />
          <DftSidebarLoaderItem />
        </div>
      </div>
    </div>
  );
};
